module.exports = __webpack_public_path__ + "static/media/star.18f411d7.png";